import { render } from "./Project.vue?vue&type=template&id=75361ad0"
import script from "./Project.vue?vue&type=script&lang=js"
export * from "./Project.vue?vue&type=script&lang=js"

import "./Project.vue?vue&type=style&index=0&id=75361ad0&lang=css"
script.render = render

export default script